import type { SubscriptionData } from "./types";
import { SubscriptionStatus } from "./types";

/**
 * Format a date string to a readable date format
 * @param dateString - The date string to format
 * @example
 * formatDate("2025-01-01") // "January 1, 2025"
 * @returns {string} The formatted date string
 */
export const formatDate = (dateString: string): string => {
  if (!dateString) return "N/A";
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return dateString;
  }
};

export const formatStatusForDisplay = (status: string | null): string => {
  if (!status) return "PENDING ACTIVATION";
  return status.replace(/_/g, " ").toUpperCase();
};

export const getButtonConfig = (
  currentStatus: string,
  onboarding: boolean,
  loading: boolean,
  subscription: SubscriptionData | null,
  onboardSuccess: boolean,
  subscriptionStatus: string | null,
) => {
  const isOnboarded = currentStatus === SubscriptionStatus.STARTED;
  const isSubmitted = currentStatus === SubscriptionStatus.NOT_STARTED;
  const isError =
    currentStatus === SubscriptionStatus.CANCELLED ||
    currentStatus === SubscriptionStatus.SUSPENDED;
  const isDisabled = onboarding || loading || !subscription || isError;

  let buttonText = "Complete Setup";
  if (onboarding) {
    buttonText = "Checking Status...";
  } else if (isOnboarded) {
    buttonText = "Setup Completed";
  } else if (isSubmitted) {
    buttonText = "Submitted";
  } else if (isError) {
    buttonText =
      currentStatus === SubscriptionStatus.CANCELLED
        ? "Cancelled"
        : "Suspended";
  } else if (onboardSuccess && subscriptionStatus) {
    buttonText = "Submitted";
  }

  return {
    text: buttonText,
    disabled: isDisabled,
  };
};
